import React from "react";
import colors from "../../utils/colors";

function LocationMap() {
  return (
    <>
      <div style={styles.mapContainer}></div>
    </>
  );
}
const styles = {
  mapContainer: {
    height: 550,
    width: "100%",
    background: colors.white,
  },
};
export default LocationMap;
